<template>
  <!-- 根组件仅负责渲染当前路由视图（单页应用入口） -->
  <router-view/>
</template>

<style lang="scss">
/*
 * 全局基础样式
 * - 保持最小视口高度，提升页面在较短内容时的背景覆盖。
 * - 字体与抗锯齿：沿用默认无衬线字体族，保证跨平台一致性。
 */
html, body {
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
#app {
  height: auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
